import {HttpParams} from '@angular/common/http';

export function toHttpParams(obj: any): HttpParams {
  let params = new HttpParams();

  Object.keys(obj).forEach(key => {
    const value = obj[key];

    if (value !== null && value !== undefined) {
      params = params.set(key, value);
    }
  });

  return params;
}

export function parseCommaSeparated(value: string): string[] {
  return (value || '')
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item.length > 0);
}
